import {
  chakra,
  omitThemingProps,
  ThemingProps,
  useStyleConfig,
  HTMLChakraProps
} from "@chakra-ui/react"
import { cx } from "@chakra-ui/utils"

interface HeadingProps extends ThemingProps<"Heading"> {}
export interface H1Props extends HTMLChakraProps<"h1">, HeadingProps {}
export interface H2Props extends HTMLChakraProps<"h2">, HeadingProps {}
export interface H3Props extends HTMLChakraProps<"h3">, HeadingProps {}
export interface H4Props extends HTMLChakraProps<"h4">, HeadingProps {}
export interface H5Props extends HTMLChakraProps<"h5">, HeadingProps {}
export interface H6Props extends HTMLChakraProps<"h6">, HeadingProps {}

export const H1 = (props: H1Props) => {
  const styles = useStyleConfig("H1", props)
  const rest = omitThemingProps(props)

  return (
    <chakra.h1
      className={cx("chakra-heading", props.className)}
      {...rest}
      __css={styles}
    />
  )
}

export const H2 = (props: H2Props) => {
  const styles = useStyleConfig("H2", props)
  const rest = omitThemingProps(props)

  return (
    <chakra.h2
      className={cx("chakra-heading", props.className)}
      {...rest}
      __css={styles}
    />
  )
}

export const H3 = (props: H3Props) => {
  const styles = useStyleConfig("H3", props)
  const rest = omitThemingProps(props)

  return (
    <chakra.h3
      className={cx("chakra-heading", props.className)}
      {...rest}
      __css={styles}
    />
  )
}

export const H4 = (props: H4Props) => {
  const styles = useStyleConfig("H4", props)
  const rest = omitThemingProps(props)

  return (
    <chakra.h4
      className={cx("chakra-heading", props.className)}
      {...rest}
      __css={styles}
    />
  )
}

export const H5 = (props: H5Props) => {
  const styles = useStyleConfig("H5", props)
  const rest = omitThemingProps(props)

  return (
    <chakra.h5
      className={cx("chakra-heading", props.className)}
      {...rest}
      __css={styles}
    />
  )
}

export const H6 = (props: H6Props) => {
  const styles = useStyleConfig("H6", props)
  const rest = omitThemingProps(props)

  return (
    <chakra.h6
      className={cx("chakra-heading", props.className)}
      {...rest}
      __css={styles}
    />
  )
}
